import { render, staticRenderFns } from "./transition-cover.vue?vue&type=template&id=6b79e321"
import script from "./transition-cover.vue?vue&type=script&lang=js"
export * from "./transition-cover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports